"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var cssFromProps = function (cssProperty) { return function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (theme ? theme.tooltip[variant][cssProperty] : 'inherit');
}; };
var TooltipContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 20.833rem;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 20.833rem;\n"])));
var TooltipBox = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 13.333rem;\n  height: 2.333rem;\n  border-radius: 0.416rem;\n  color: ", ";\n"], ["\n  width: 13.333rem;\n  height: 2.333rem;\n  border-radius: 0.416rem;\n  color: ", ";\n"])), theme_1.colors.white);
var EnvirioTooltip = function (_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, style = _a.style;
    return (React.createElement(TooltipContainer, { style: __assign({}, (style || {})) },
        React.createElement(TooltipBox, { className: className, onClick: typeof onClick === 'function' ? onClick : undefined },
            React.createElement("span", { style: {
                    display: 'flex',
                    margin: theme_1.spacing.mini,
                    verticalAlign: '-webkit-baseline-middle',
                    flexDirection: 'column'
                } }, children))));
};
exports.Tooltip = styled_1.default(EnvirioTooltip)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  background-color: rgba(0, 36, 45, 0.9);\n  position: relative;\n\n  & ::before {\n    content: '';\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    top: ", ";\n    left: ", ";\n    border-width: ", ";\n    border-color: ", ";\n    border-style: solid;\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  background-color: rgba(0, 36, 45, 0.9);\n  position: relative;\n\n  & ::before {\n    content: '';\n    position: absolute;\n    height: 0px;\n    width: 0px;\n    top: ", ";\n    left: ", ";\n    border-width: ", ";\n    border-color: ", ";\n    border-style: solid;\n  }\n"])), cssFromProps('width'), cssFromProps('height'), cssFromProps('top'), cssFromProps('left'), cssFromProps('borderWidth'), cssFromProps('borderColor'));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map